import React from "react";
import PropTypes from "prop-types";
import Isvg from "../../../../vendor/react-inlinesvg";

class BookmarkMenuItem extends React.Component {
  constructor(props) {
    super(props);

    this._clickBookmark = this._clickBookmark.bind(this);
    this._goToBookmark = this._goToBookmark.bind(this);
    this._removeBookmark = this._removeBookmark.bind(this);
  }

  _clickBookmark(e) {
    this._removeMenu();
  }

  _goToBookmark(e) {
    this.props.goToBookmark(e, this.props.bookmark);
  }

  _removeBookmark(e) {
    e.stopPropagation();
    this.props.removeBookmark(this.props.bookmark);
  }

  // This is displayed if there are no bookmarks yet
  renderEmptyBookmark() {
    return (
      <li
        key={"menu-list-item-empty"}
        className={"context-menu-option bookmark-option empty-bookmark-message"}
        data-item-id={"empty"}
        tabIndex={0}
      >
        <span className="empty-bookmark-message">
          {window.toHTML(
            i18n.t("bookmarks.tap-to-add", {
              icon: `<img src="/img/bookmark_dark.svg" alt="${i18n.t(
                "bookmarks.bookmark-button"
              )}"></img>`
            })
          )}
        </span>
      </li>
    );
  }

  render() {
    if (!this.props.bookmark) {
      return this.renderEmptyBookmark();
    }
    // This is displayed if there are 1 or more bookmarks
    return (
      <li
        key={"menu-list-item" + this.props.bookmark.guid}
        className={
          "context-menu-option bookmark-option bookmark-list-" +
          this.props.bookmark.guid
        }
        data-item-id={this.props.bookmark.guid}
      >
        <a href="#" className="bookmark-title" onClick={this._goToBookmark}>
          {this.props.bookmark.chapterTitle}
        </a>
        <button
          className="bookmark-delete-button noButton"
          onClick={this._removeBookmark}
          aria-label={i18n.t("bookmarks.remove-bookmark")}
        >
          <Isvg src="/img/x_gray.svg" />
        </button>
        <span className="bookmark-page">{this.props.bookmark.page}</span>
      </li>
    );
  }
}

BookmarkMenuItem.propTypes = {
  bookmark: PropTypes.shape({
    guid: PropTypes.string,
    page: PropTypes.string,
    chapterTitle: PropTypes.string
  })
};

BookmarkMenuItem.defaultProps = {
  bookmark: null
};

module.exports = BookmarkMenuItem;
